class ConversationWorkerService {
  private worker: Worker;
  private listeners: ((data: any) => void)[] = [];

  constructor() {
    this.worker = new Worker(new URL('@/workers/conversations/real-time-pipeline.worker.ts', import.meta.url), {
      type: 'module',
    });

    this.worker.onmessage = (e) => {
      this.listeners.forEach((callback) => callback(e.data));
    };
  }

  post(data: any) {
    this.worker.postMessage(data);
  }

  onMessage(callback: (data: any) => void) {
    if (!this.listeners.includes(callback)) {
      this.listeners.push(callback);
    }
  }

  offMessage(callback: (data: any) => void) {
    this.listeners = this.listeners.filter((fn) => fn !== callback);
  }

  terminate() {
    this.worker.terminate();
    this.listeners = [];
  }
}

export const conversationWorker = new ConversationWorkerService();
